import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon, Heart, Trophy, Star } from 'lucide-react';
import { PackComparisonTable } from './PackComparisonTable';
export function PricingSection() {
  const [selected, setSelected] = useState<'combo' | 'base'>('combo');
  return <section className="py-20 px-4 bg-slate-950" id="pricing" aria-labelledby="pricing-heading" data-id="element-119">
      <div className="max-w-2xl mx-auto" data-id="element-120">
        {/* Header */}
        <FadeIn className="text-center mb-10" data-id="element-121">
          <h2 id="pricing-heading" className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-122">
            ELEGÍ TU OPCIÓN
          </h2>
          <p className="text-slate-400" data-id="element-123">
            Seleccioná el pack que mejor se adapte a tu objetivo.
          </p>
        </FadeIn>

        {/* Selection Cards */}
        <FadeIn delay={0.1} data-id="element-124">
          <div className="space-y-4 mb-8" data-id="element-125">
            {/* Combo Pro */}
            <button onClick={() => setSelected('combo')} aria-pressed={selected === 'combo'} aria-label="Seleccionar Combo Pro — 6 tomos + 2 bonos + Pelotón 10X por $29.990" className={`w-full text-left rounded-2xl p-6 border-2 transition-all duration-300 ${selected === 'combo' ? 'border-green-500 bg-slate-900 shadow-[0_0_20px_rgba(34,197,94,0.1)]' : 'border-slate-800 bg-slate-900/50 opacity-70'}`} data-id="element-126">
              <div className="flex items-start gap-4" data-id="element-127">
                {/* Radio */}
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center ${selected === 'combo' ? 'border-green-500 bg-green-500' : 'border-slate-600'}`} aria-hidden="true" data-id="element-128">
                  {selected === 'combo' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-129" />}
                </div>

                <div className="flex-grow" data-id="element-130">
                  <div className="flex items-center justify-between flex-wrap gap-2 mb-3" data-id="element-131">
                    <div className="flex items-center gap-2" data-id="element-132">
                      <Trophy className="w-5 h-5 text-amber-500" data-id="element-133" />
                      <span className="text-xl font-bold text-white" data-id="element-134">
                        COMBO PRO
                      </span>
                    </div>
                    <div className="text-right" data-id="element-135">
                      <span className="text-slate-500 line-through text-sm mr-2" data-id="element-136">
                        $39.980
                      </span>
                      <span className="text-2xl font-bold text-green-500" data-id="element-137">
                        $29.990
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-138">
                    <span className="inline-flex items-center gap-1 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-139">
                      <Star size={12} data-id="element-140" /> MÁS ELEGIDO
                    </span>
                    <span className="inline-flex items-center border border-green-500 text-green-500 text-xs font-bold px-3 py-1 rounded-full" data-id="element-141">
                      AHORRÁS $10.000
                    </span>
                  </div>

                  <p className="text-slate-300 text-sm mb-1" data-id="element-142">
                    6 tomos + 2 bonos
                  </p>
                  <p className="text-white font-bold text-sm mb-2" data-id="element-143">
                    + Pelotón 10X
                  </p>
                  <p className="text-slate-400 text-xs" data-id="element-144">
                    - Sistema de Posicionamiento en Pelotón
                  </p>
                  <p className="text-slate-400 text-xs" data-id="element-145">
                    - Tácticas de Viento Argentinas
                  </p>
                </div>
              </div>
            </button>

            {/* Pack Base */}
            <button onClick={() => setSelected('base')} aria-pressed={selected === 'base'} aria-label="Seleccionar Pack Base — 6 tomos + 2 bonos por $19.990" className={`w-full text-left rounded-2xl p-6 border-2 transition-all duration-300 ${selected === 'base' ? 'border-green-500 bg-slate-900 shadow-[0_0_20px_rgba(34,197,94,0.1)]' : 'border-slate-800 bg-slate-900/50 opacity-70'}`} data-id="element-146">
              <div className="flex items-center gap-4" data-id="element-147">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'base' ? 'border-green-500 bg-green-500' : 'border-slate-600'}`} aria-hidden="true" data-id="element-148">
                  {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-149" />}
                </div>

                <div className="flex items-center justify-between flex-grow flex-wrap gap-2" data-id="element-150">
                  <div data-id="element-151">
                    <div className="flex items-center gap-2 mb-1" data-id="element-152">
                      <span className="text-green-500" data-id="element-153">💚</span>
                      <span className="text-xl font-bold text-white" data-id="element-154">
                        PACK BASE
                      </span>
                    </div>
                    <p className="text-slate-400 text-sm" data-id="element-155">6 tomos + 2 bonos</p>
                  </div>
                  <div className="text-right" data-id="element-156">
                    <span className="text-slate-500 line-through text-sm mr-2" data-id="element-157">
                      $36.500
                    </span>
                    <span className="text-2xl font-bold text-green-500" data-id="element-158">
                      $19.990
                    </span>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </FadeIn>

        {/* Main CTA Button */}
        <FadeIn delay={0.2} data-id="element-159">
          <a href={selected === 'combo' ? 'https://fegion.shop/cart/46201151553675:1' : 'https://fegion.shop/cart/46201145950347:1'} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-3 py-5 px-6 rounded-2xl bg-green-600 hover:bg-green-500 text-white font-black text-xl transition-colors shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:shadow-[0_0_30px_rgba(34,197,94,0.4)]" aria-label={`Comprar ${selected === 'combo' ? 'Combo Pro por $29.990' : 'Pack Base por $19.990'}`} data-id="element-160">
            <Heart size={22} fill="white" aria-hidden="true" data-id="element-161" />
            EMPEZAR HOY — ${selected === 'combo' ? '29.990' : '19.990'}
          </a>
        </FadeIn>

        {/* Divider */}
        <div className="my-16 border-t border-slate-800" data-id="element-162" />

        {/* Pack Comparison Table + Callout */}
        <div className="mb-16 -mx-4 md:mx-0" data-id="element-163">
          <PackComparisonTable data-id="element-164" />
        </div>

        {/* Final CTA Section */}
        <div className="space-y-8 text-center" data-id="element-165">
          <FadeIn delay={0.3} data-id="element-166">
            <p className="text-red-500 font-bold flex items-center justify-center gap-2 text-lg" data-id="element-167">
              🔴 ELEGÍ TU OPCIÓN:
            </p>
          </FadeIn>

          {/* Option A */}
          <FadeIn delay={0.4} data-id="element-168">
            <div className="bg-slate-900 border-2 border-green-500/40 rounded-2xl p-8 shadow-lg" data-id="element-169">
              <p className="text-red-500 font-bold text-sm tracking-wider mb-4" data-id="element-170">
                OPCIÓN A — PACK COMPLETO RECOMENDADO
              </p>
              <h4 className="text-2xl md:text-3xl text-white font-bold mb-6" data-id="element-171">
                PROTORRENDA 4-12 + Pelotón 10X
              </h4>
              <div className="flex items-center justify-center gap-3 mb-8" data-id="element-172">
                <span className="text-slate-500 line-through text-lg" data-id="element-173">
                  $39.980
                </span>
                <span className="text-slate-400" data-id="element-174">→</span>
                <span className="text-3xl font-black text-green-500" data-id="element-175">
                  $29.990
                </span>
                <span className="text-slate-400 text-sm" data-id="element-176">ARS</span>
              </div>

              <a href="https://fegion.shop/cart/46201151553675:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-5 px-6 rounded-xl bg-green-600 hover:bg-green-500 text-white font-black text-xl transition-colors shadow-lg mb-6" aria-label="Comprar Pack Completo PROTORRENDA 4-12 + Pelotón 10X por $29.990" data-id="element-177">
                → SÍ, QUIERO EL COMBO COMPLETO ←
              </a>

              <div className="flex flex-wrap justify-center gap-3 text-sm text-slate-400" data-id="element-178">
                <span data-id="element-179">✅ Todo incluido</span>
                <span data-id="element-180">·</span>
                <span data-id="element-181">✅ Acceso inmediato</span>
                <span data-id="element-182">·</span>
                <span data-id="element-183">✅ Garantía 7 días</span>
              </div>
            </div>
          </FadeIn>

          {/* Divider */}
          <FadeIn delay={0.5} data-id="element-184">
            <div className="flex items-center gap-4 py-2" data-id="element-185">
              <div className="flex-grow border-t border-slate-800" data-id="element-186"></div>
              <span className="text-slate-600 text-sm" data-id="element-187">o</span>
              <div className="flex-grow border-t border-slate-800" data-id="element-188"></div>
            </div>
          </FadeIn>

          {/* Option B */}
          <FadeIn delay={0.6} data-id="element-189">
            <div data-id="element-190">
              <p className="text-slate-500 font-bold text-sm tracking-wider mb-3" data-id="element-191">
                OPCIÓN B — SOLO EL PACK BASE
              </p>
              <p className="text-2xl font-bold text-white mb-6" data-id="element-192">$19.990 ARS</p>
              <a href="https://fegion.shop/cart/46201145950347:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center py-4 px-6 rounded-xl bg-amber-600 hover:bg-amber-500 text-white font-bold text-lg transition-colors" aria-label="Comprar solo el Pack Base de PROTORRENDA 4-12 por $19.990" data-id="element-193">
                No gracias, prefiero solo el Pack Base de PROTORRENDA 4-12
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}